
        var result = require("!!../../../../node_modules/css-loader/index.js!./registration.details.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Client/app/views/registration/registration.details.component.css
// module id = 1448
// module chunks = 0